import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { consumeRedirect } from '../utils/postLoginRedirect';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    const processAuthCallback = () => {
      try {
        console.log('🔍 Processing auth callback...');
        
        // Get data from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const encodedData = urlParams.get('data');
        
        if (!encodedData) {
          console.error('❌ No authentication data found in URL');
          navigate('/login');
          return;
        }

        console.log('📦 Decoding authentication data...');
        
        // Decode the base64 data
        const decodedData = atob(encodedData);
        const authData = JSON.parse(decodedData);
        
        console.log('✅ Authentication data received:', authData);

        if (authData.type === 'MICROSOFT_AUTH_SUCCESS') {
          // Store tokens
          localStorage.setItem('token', authData.token);
          localStorage.setItem('refreshToken', authData.refreshToken);
          
          // Set user in context (will be handled by parent)
          if (window.opener) {
            // If opened as popup, send message to parent and close
            console.log('📨 Sending data to parent window...');
            window.opener.postMessage(authData, window.location.origin);
            window.close();
          } else {
            // If opened as regular page, go back to where they were heading, else by role
            const redirectPath = consumeRedirect() || (authData.user?.role === 'partner' ? '/tasks' : '/dashboard');
            console.log(`🚀 Redirecting to ${redirectPath}...`);
            window.location.href = redirectPath;
          }
        } else {
          console.error('❌ Authentication failed');
          navigate('/login');
        }
      } catch (error) {
        console.error('❌ Error processing authentication callback:', error);
        navigate('/login');
      }
    };

    processAuthCallback();
  }, [location, navigate, setUser]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default AuthCallback;
